import { Button, PageHeader, Tag } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { CLIENT_STATUS } from '../../types/Client';
import { FORM_MODE } from '../../types/Form';
import { useClientFormContext } from '../../views/Client/ClientFormContext';

const ClientFormHeader: React.FC = (): React.ReactElement => {
    const { formConfig, mode, client, clientId } = useClientFormContext();
    const history = useHistory();

    return (
        <PageHeader
            className="site-page-header py-2 justify-content-end"
            title={<p className="h5 m-0 text-left">{formConfig.setupModes[mode].title}</p>}
            extra={[
                client?.status === CLIENT_STATUS.DELETED && (
                    <p key="deleted-tag">
                        <span className="d-inline-block mr-2">Status:</span>
                        <Tag color="red" className="text-uppercase">
                            {client?.status}
                        </Tag>
                    </p>
                ),
                formConfig.isDetailMode && client?.status !== CLIENT_STATUS.DELETED && (
                    <Button
                        key="btn-edit-client-data"
                        id="btn-edit-client-data"
                        name="btn-edit-client-data"
                        title="Edit client"
                        className="btn-primary bg-primary text-white"
                        onClick={(): void => history.push(`/admin/clients/${FORM_MODE.EDIT}/${clientId}`)}
                    >
                        Edit client
                    </Button>
                ),
            ]}
        />
    );
};

export default ClientFormHeader;
